import React from "react";
import useFetch from "../../../utils/hooks/useFetch";
import { reportEndpoints } from "../../../api/endpoints/report.endpoints";
import { Link } from "react-router-dom";
import { convertDateToDDMMYYYY } from "../../../utils/dateFunctions";

const DraftsTable = ({ search }) => {
  const {
    data: draftsData,
    loading: draftsLoading,
    error: draftsError,
  } = useFetch(reportEndpoints.getReports, {
    status: "draft",
  });

  const headings = ["Report Name", "Last edited", "Progress", "Actions"];

  const filteredReports = draftsData?.reports?.filter((item) =>
    item?.name?.toLowerCase()?.includes(search?.toLowerCase())
  );
  const calculateProgress = (completedStatus) => {
    const done = completedStatus?.done || 0;
    const total = completedStatus?.total || 0;
    
    // If total is 0, return 0 to avoid division by zero
    if (total === 0) return 0;
    
    // Calculate progress and round to 2 decimal places
    return ((done / total) * 100).toFixed(2);
  };


  const hasSearchQuery = Boolean(search?.trim());
  const emptyMessage = hasSearchQuery
    ? "No draft reports match your search."
    : "No draft reports yet. Create a report to get started.";

  return (
    <div className="reports-table-container">
      <div className="reports-table">
        <div className="reports-table-row reports-table-header">
          {headings.map((item) => (
            <div key={item} className="reports-table-cell">
              {item}
            </div>
          ))}
        </div>
        {draftsLoading ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              Loading draft reports...
            </div>
          </div>
        ) : draftsError ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              Unable to load draft reports right now.
            </div>
          </div>
        ) : (filteredReports?.length || 0) === 0 ? (
          <div className="reports-table-row reports-empty-state-row">
            <div className="reports-table-cell reports-empty-state-cell" style={{ flex: 1 }}>
              {emptyMessage}
            </div>
          </div>
        ) : (
          filteredReports.map((item) => {
            const progress = calculateProgress(item?.completedStatus);

            return (
              <div key={item?.id} className="reports-table-row">
                <div className="reports-table-cell">{item?.name}</div>
                <div className="reports-table-cell">
                  {convertDateToDDMMYYYY(item?.lastEdited)}
                </div>
                <div className="reports-table-cell ">{progress}%</div>
                <div className="reports-table-cell ">
                  <Link to={`/add-data-points/${item?.id}`}>
                    <button className="report-actions-btn">Preview</button>
                  </Link>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default DraftsTable;
